import trackSerpLoaded from './trackSerpLoaded';

// Runs on Page load
trackSerpLoaded({ pathname: window.location.pathname });
